var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 73,
    viewBox: "0 0 62 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5971 15.3846L9.75794 49.9296C9.29346 52.2757 10.8381 54.6043 13.1689 55.0718L14.2138 55.2814L47.4891 61.9558C49.82 62.4233 52.1334 60.8686 52.5979 58.5225L60.9266 16.4536L61.1509 15.321C61.6154 12.9748 60.0708 10.6463 57.7399 10.1787L32.0199 5.01977",
    fill: "#DFEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5971 15.3846L9.75794 49.9296C9.29345 52.2757 10.8381 54.6043 13.1689 55.0718L14.2138 55.2814L47.4891 61.9558C49.82 62.4233 52.1334 60.8686 52.5979 58.5225L60.9266 16.4536L61.1509 15.321C61.6154 12.9748 60.0708 10.6463 57.7399 10.1787L32.0199 5.01977",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0204 5.01953L29.4577 17.9638L16.5977 15.3843L32.0204 5.01953Z",
    fill: "#AEB5BC",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5568 13.3079L54.0161 47.4875C54.5906 49.8088 53.1575 52.2085 50.8512 52.7868L49.8174 53.046L16.8941 61.3015C14.5878 61.8798 12.2038 60.4372 11.6293 58.1159L1.32758 16.492L1.05022 15.3713C0.475707 13.05 1.90884 10.6503 4.21507 10.072L29.6631 3.69101",
    fill: "#9CCED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5568 13.3079L54.0161 47.4875C54.5906 49.8088 53.1575 52.2085 50.8512 52.7868L49.8174 53.046L16.8941 61.3015C14.5878 61.8798 12.2038 60.4372 11.6293 58.1159L1.32758 16.492L1.05022 15.3713C0.475707 13.05 1.90884 10.6503 4.21507 10.072L29.6631 3.69101",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6631 3.69141L32.8328 16.4988L45.5568 13.3082L29.6631 3.69141Z",
    fill: "#AEB5BC",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8771 18.2281V53.4523C53.8771 55.8446 51.9101 57.8244 49.5334 57.8244H48.468H14.5385C12.1618 57.8244 10.1948 55.8446 10.1948 53.4523V10.5563V9.40139C10.1948 7.00911 12.1618 5.0293 14.5385 5.0293H40.7642",
    fill: "#F6FBFB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8771 18.2281V53.4523C53.8771 55.8446 51.9101 57.8244 49.5334 57.8244H48.468H14.5385C12.1618 57.8244 10.1948 55.8446 10.1948 53.4523V10.5563V9.40139C10.1948 7.00911 12.1618 5.0293 14.5385 5.0293H40.7642",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7642 5.0293V18.2281H53.877L40.7642 5.0293Z",
    fill: "#CFD4D9",
    stroke: "#4A5056",
    strokeWidth: 1.35943,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1547 56.5001C61.1547 64.8781 54.4086 71.6604 46.0984 71.6604C37.7883 71.6604 31.0422 64.8781 31.0422 56.5001C31.0422 48.122 37.7883 41.3397 46.0984 41.3397C54.4086 41.3397 61.1547 48.122 61.1547 56.5001Z",
    fill: "#319AA4",
    stroke: "#4A5056",
    strokeWidth: 1.67938
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2213_937",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 47,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37.0151,
    y: 47.3574,
    width: 18.1668,
    height: 18.2858,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2213_937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3414 62.5968V53.3205L41.1025 57.5872L40.0427 56.5015L46.0983 50.4062L52.1539 56.5015L51.0942 57.5872L46.8553 53.3205V62.5968H45.3414Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBrowse);
export default __webpack_public_path__ + "static/media/upload-browse.da9e00d57d9e004a94084813b0696ff3.svg";
export { ForwardRef as ReactComponent };